export const TECHNOLOGY_CATEGORIES = [
  {
    category: "SIEM / SOAR",
    keyVendors: "Splunk, Google Chronicle, Innspark, Gurucul, Securonix, Opentext Arcsight, Sumologic",
    controlsAddressed:
      "RBI: SOC-01, SOC-02, SOC-03, SOC-04, SOC-05 | CERT-In: CERT-11, CERT-12, CERT-13, CERT-15 | SEBI: CSCRF-SEC-01, CSCRF-SEC-02 | IRDAI: IRDAI-SOC-01",
    automationPercent: 85,
  },
  {
    category: "IAM / PAM / IGA",
    keyVendors: "RSA, Opentext NetIQ, CyberArk, 1Kosmos, Yubico, e-Mudra, Entrust IDAAS",
    controlsAddressed:
      "RBI: IAM-01..12 | SEBI: CSCRF-IAM-01, CSCRF-IAM-02 | IRDAI: IRDAI-IAM-01, IRDAI-IAM-02",
    automationPercent: 90,
  },
  {
    category: "DLP / DSPM",
    keyVendors: "Forcepoint, Varonis",
    controlsAddressed: "RBI: DAT-01..10 | SEBI: CSCRF-DATA-02 | IRDAI: IRDAI-DATA-01..03",
    automationPercent: 80,
  },
  {
    category: "CSPM / CWPP / CNAPP",
    keyVendors: "Wiz, Check Point CloudGuard",
    controlsAddressed: "ISO: A.5 / A.8 cloud controls; NIST CSF PR/DE",
    automationPercent: 85,
  },
  {
    category: "VA/PT Tools",
    keyVendors: "Tenable",
    controlsAddressed: "RBI: VUL-01..08 | SEBI: CSCRF-VAPT-01..02",
    automationPercent: 90,
  },
  {
    category: "GRC Platforms",
    keyVendors: "ServiceNow, Archer, MetricStream",
    controlsAddressed: "RBI: GOV/RISK | SEBI: GOV/RISK | ISO clauses",
    automationPercent: 70,
  },
  {
    category: "EDR / XDR",
    keyVendors: " SentinelOne, Check Point",
    controlsAddressed: "RBI: END-01..09 | CERT-In: CERT-06",
    automationPercent: 85,
  },
  {
    category: "Network Security",
    keyVendors: "Arista, Check Point, Alcatel-Lucent, check iValue Network security stack",
    controlsAddressed: "RBI: NET-01..14 | CERT-In: CERT-09",
    automationPercent: 80,
  },
  {
    category: "Email Security",
    keyVendors: "Check Point",
    controlsAddressed: "RBI: NET-08 | CERT-In: CERT-08",
    automationPercent: 85,
  },
  {
    category: "OT Security",
    keyVendors: "Tenable, Terafence",
    controlsAddressed: "OT/ICS: Purdue-level monitoring and anomaly detection",
    automationPercent: 75,
  },
];
